export const TRADE_NPC_CATALOG_SCHEMA = "fishystuff.trade_npc_destinations";
export const TRADE_NPC_CATALOG_VERSION = 4;

export const TRADE_NPC_CLASS_TRADER = "trader";
export const TRADE_NPC_CLASS_IMPERIAL_FISHING_DELIVERY = "imperial_fishing_delivery";
export const TRADE_NPC_CLASS_BARTER = "barter";
export const TRADE_NPC_LAYER_ID = "trade_npcs";
export const IMPERIAL_FISHING_DELIVERY_ICON_PATH = "/images/items/00001019.webp";
export const BARTER_NPC_ICON_PATH = "/images/items/barter-npc-marker-v2.webp";

export const TRADE_NPC_CLASS_DEFINITIONS = Object.freeze([
  Object.freeze({
    id: TRADE_NPC_CLASS_TRADER,
    label: "Trade Manager",
    defaultVisible: true,
    iconPath: "/images/items/trade-npc-marker-v2.webp",
  }),
  Object.freeze({
    id: TRADE_NPC_CLASS_IMPERIAL_FISHING_DELIVERY,
    label: "Imperial Fishing Delivery",
    defaultVisible: true,
    iconPath: IMPERIAL_FISHING_DELIVERY_ICON_PATH,
  }),
  Object.freeze({
    id: TRADE_NPC_CLASS_BARTER,
    label: "Barter NPC",
    defaultVisible: false,
    iconPath: BARTER_NPC_ICON_PATH,
  }),
]);

export const TRADE_NPC_CLASS_IDS = Object.freeze(
  TRADE_NPC_CLASS_DEFINITIONS.map((definition) => definition.id),
);
const TRADE_NPC_CLASS_ID_SET = new Set(TRADE_NPC_CLASS_IDS);

export const DEFAULT_VISIBLE_TRADE_NPC_CLASSES = Object.freeze(
  TRADE_NPC_CLASS_DEFINITIONS
    .filter((definition) => definition.defaultVisible)
    .map((definition) => definition.id),
);

export function normalizeTradeNpcClass(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return TRADE_NPC_CLASS_ID_SET.has(normalized) ? normalized : "";
}

export function normalizeVisibleTradeNpcClasses(value) {
  const selected = new Set(
    (Array.isArray(value) ? value : [])
      .map(normalizeTradeNpcClass)
      .filter(Boolean),
  );
  return TRADE_NPC_CLASS_DEFINITIONS
    .map((definition) => definition.id)
    .filter((classId) => selected.has(classId));
}

export function isTradeNpcLayerId(value) {
  return String(value ?? "").trim() === TRADE_NPC_LAYER_ID;
}
